import React, { useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import AlphaCredentialsModal from './AlphaCredentialsModal';
import { REQUIRE_ALPHA_CREDENTIALS } from '../../config';

export default function HeroSection() {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const [showCredentialsModal, setShowCredentialsModal] = useState(false);

  const handleSignIn = () => {
    if (REQUIRE_ALPHA_CREDENTIALS) {
      setShowCredentialsModal(true);
    } else {
      // Bypass alpha gate - go directly to Auth0
      handleProceedToLogin();
    }
  };

  const handleProceedToLogin = async () => {
    setShowCredentialsModal(false);
    
    try {
      if (loginWithRedirect) {
        await loginWithRedirect({
          authorizationParams: {
            redirect_uri: `${window.location.origin}/callback`,
          }
        });
      }
    } catch (err) {
      console.error('Login failed:', err);
    }
  };

  return (
    <section className="flex flex-col justify-center items-center text-center px-4 bg-white min-h-[60vh] md:min-h-[60vh]">
      <h1 className="text-5xl md:text-7xl font-bold mb-4">
        Attendance <span className="text-blue-600 underline decoration-wavy">made simple</span>
        <span className="block mt-2 text-5xl md:text-7xl font-bold">for everyone.</span>
      </h1>
      <p className="text-lg text-gray-600 mb-8 max-w-xl mx-auto">
        A modern, user-friendly platform that makes attendance tracking effortless for schools and after-school programs.
      </p>
      <div className="flex flex-col md:flex-row justify-center gap-4">
        {!isAuthenticated ? (
          <>
            <button 
              onClick={handleSignIn}
              className="bg-blue-600 text-white px-6 py-3 rounded-full font-semibold shadow hover:bg-blue-700 transition"
            >
              Get started - Alpha Access
            </button>
            <button className="border border-gray-300 px-6 py-3 rounded-full font-semibold flex items-center justify-center gap-2 hover:bg-gray-100 transition">
              <span>Watch video</span>
            </button>
          </>
        ) : (
          <a 
            href="/onboarding"
            className="bg-blue-600 text-white px-6 py-3 rounded-full font-semibold shadow hover:bg-blue-700 transition inline-block"
          >
            Go to Dashboard
          </a>
        )}
      </div>

      {/* Alpha Credentials Modal */}
      <AlphaCredentialsModal
        isOpen={showCredentialsModal}
        onClose={() => setShowCredentialsModal(false)}
        onProceedToLogin={handleProceedToLogin}
      />
    </section>
  );
} 